/**
 * Do not edit directly, this file was auto-generated.
 */

export const Space0 = "0px";
export const Space1 = "4px";
export const Space2 = "8px";
export const Space3 = "12px";
export const Space4 = "16px";
export const Space5 = "20px";
export const Space6 = "24px";
export const Space8 = "32px";
export const Space10 = "40px";
export const Space12 = "48px";
export const Space16 = "64px";
export const Space20 = "80px";
export const Space24 = "96px";
export const Space32 = "128px";
export const Space40 = "160px";
export const Space05 = "2px";
export const SpaceBase = "4px";
